/* Barra «te falta X para envío gratis» en el carrito (lateral y página de carrito) - Dear Noel
   El envío es gratis cuando los productos con ese perfil de envío suman $100.000 o más.
   No cuenta la «protección de envío» porque tiene otro perfil de envío. */
(function () {
  if (window.__dnFree) return; window.__dnFree = true;
  var MIN = 100000, SKIP = 'proteccion-de-envio';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var timer = null, busy = false;
  function money(n) { return '$' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function css() {
    if (document.getElementById('dn-free-css')) return;
    var s = document.createElement('style'); s.id = 'dn-free-css';
    s.textContent = '.dn-free{margin:12px 20px 0;padding:10px 12px 12px;border-radius:12px;background:#f1f6ff;border:1px solid #d6e2ff;font-size:13px;line-height:1.35;color:#111;text-align:center}' +
      'cart-items>.dn-free,.page-width>.dn-free{margin:12px 0}' +
      '.dn-free b{font-weight:700}.dn-free small{display:block;margin-top:2px;color:#5c6070;font-size:11.5px}' +
      '.dn-free__t{height:6px;border-radius:6px;background:#e3e6fc;margin:8px 6% 0;overflow:hidden}' +
      '.dn-free__t span{display:block;height:100%;border-radius:6px;background:#4f5bf5;transition:width .4s ease}' +
      '.dn-free--ok{background:#e8f3ec;border-color:#bfe0cb}.dn-free--ok .dn-free__t span{background:#2f7d4f}' +
      '@media(max-width:749px){.dn-free{margin:10px 16px 0}}';
    document.head.appendChild(s);
  }
  function html(sum) {
    var missing = MIN - sum, pct = Math.max(4, Math.min(100, Math.round(sum / MIN * 100)));
    var txt = missing > 0
      ? '🚚 Te faltan <b>' + money(missing) + '</b> para el envío gratis<small>Agrega otra unidad y el envío no te cuesta nada</small>'
      : '🎉 <b>¡Tienes envío gratis!</b>';
    return { cls: 'dn-free' + (missing <= 0 ? ' dn-free--ok' : ''), inner: txt + '<div class="dn-free__t"><span style="width:' + pct + '%"></span></div>' };
  }
  function hosts() {
    var h = [];
    var drawer = document.querySelector('#CartDrawer .drawer__header');
    if (drawer) h.push({ el: drawer, mode: 'after' });
    var page = document.querySelector('cart-items');
    if (page && !page.closest('#CartDrawer')) h.push({ el: page, mode: 'before' });
    return h;
  }
  async function update() {
    if (busy) return; busy = true;
    try {
      css();
      var cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      var sum = 0, n = 0;
      cart.items.forEach(function (i) { if (i.handle !== SKIP) { sum += i.final_line_price / 100; n += i.quantity; } });
      document.querySelectorAll('.dn-free').forEach(function (b) { if (!n) b.remove(); });
      if (!n) return;
      var v = html(sum);
      hosts().forEach(function (h) {
        var bar = h.mode === 'after' ? (h.el.nextElementSibling && h.el.nextElementSibling.classList.contains('dn-free') ? h.el.nextElementSibling : null)
                                      : (h.el.previousElementSibling && h.el.previousElementSibling.classList.contains('dn-free') ? h.el.previousElementSibling : null);
        if (!bar) { bar = document.createElement('div'); h.el.insertAdjacentElement(h.mode === 'after' ? 'afterend' : 'beforebegin', bar); }
        if (bar.className !== v.cls) bar.className = v.cls;
        if (bar.innerHTML !== v.inner) bar.innerHTML = v.inner;
      });
    } catch (e) {} finally { busy = false; }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(update, 150); }
  function start() {
    schedule();
    new MutationObserver(function (m) {
      for (var k = 0; k < m.length; k++) { if (m[k].target && m[k].target.closest && m[k].target.closest('.dn-free')) return; }
      schedule();
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
